import downloadTrack from '../downloadTrack';

export default host => (musicId) => downloadTrack(host, musicId, 'music')